import React from 'react';
import { Button } from 'reactstrap';

const FilterSelector = ({ selectedFilter, setSelectedFilter }) => {

  const filters = [
    { label: 'Name', value: 'name' },
    { label: 'Address', value: 'installedAddress' },
    { label: 'Serial Number', value: 'serialNumber' },
  ];

  const handleSelect = value => {
    setSelectedFilter(value);
  };

  return (
    <div className="d-flex gap-2 flex-wrap">
      {filters.map(filter => (
        <Button
          key={filter.value}
          onClick={() => handleSelect(filter)}
          size="sm"
          className={`rounded-pill px-3 py-1 filter-pill ${selectedFilter.value === filter.value ? '' : 'border-secondary text-muted'}`}
          style={{
          
            backgroundColor: selectedFilter.value === filter.value ? '#3F8684' : '#F2F2F2',
            border: 'none !important'
          }}
        >
          {filter.label}
        </Button>
      ))}
    </div>
  );
};

export default FilterSelector;
